import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  data: {},
  success: null,
};

const postNewsLetterSlice = createSlice({
  name: "postNewsLetter",
  initialState,
  reducers: {
    postNewsLetterStart(state, payload) {
      state.loading = true;
      state.error = null;
    },

    postNewsLetterSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data.data;
      state.success = action.payload.data.message;
    },
    postNewsLetterFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
    clearLoading: (state) => {
      state.loading = false;
    },
  },
});

export const {
  postNewsLetterStart,
  postNewsLetterSuccess,
  postNewsLetterFailure,
  clearState,
  clearLoading,
} = postNewsLetterSlice.actions;

export default postNewsLetterSlice.reducer;
